import { createStore } from 'vuex'
import axios from 'axios'
import CountriesService from "@/services/countries.service";
import TokenService from "@/services/token.service";
import MarketService from '@/services/market.service';
import AccountService from '@/services/account.service';
// import TransactionService from '@/services/transaction.service';

export default createStore({
  state: {
    baseAPIUrl : process.env.VUE_APP_API_URL,
    // accountSlug : process.env.VUE_APP_ACCOUNT_SLUG,
    currencyCode : process.env.VUE_APP_CURRENCY_CODE,
    locale : process.env.VUE_APP_LOCALE || 'en',
    accountProducts: {},
    pastDrawResults: {},
    pastGameResults: {},
    carouselProducts : [],
    customerToken: '',
    markets: [],
    settings: {},
    draws: [],
    cartRetail: [],
    translations: {},
    badgeNumber: 0,
    badgeNumberRetail: 0,
    token: '',
    account: '',
    currencySymbol: process.env.VUE_APP_CURRENCY_SYMBOL,
    isLoadingMarkets: false,
    paramsLuckyNumber:{},
  },
  getters: {
    getCurrencyCode (state) {
      return state.currencyCode
    },
    getCartRetail (state) {
      return state.cartRetail
    },
    getToken (state) {
      return state.token
    },
    getAccount (state) {
      return state.account
    },
    getCustomerToken (state) {
      return state.customerToken
    },
    getCarouselProducts (state) {
      return state.carouselProducts
    },
    getAccountProducts (state) {
      return state.accountProducts
    },
    getPastDrawResults (state) {
      return state.pastDrawResults
    },
    getPastGameResults (state) {
      return state.pastGameResults
    },
    getMarkets (state) {
      return state.markets
    },
    getSettings (state) {
      return state.settings
    },
    getDraws (state) {
      return state.draws
    },
    getTranslations (state) {
      return state.translations
    },
    getBadgeNumber(state) {
      return state.badgeNumber
    },
    getBadgeNumberRetail(state) {
      return state.badgeNumberRetail
    },
    getParamsLuckyNumber(state) {
      return state.paramsLuckyNumber
    }
  },
  mutations: {
    SET_CURRENCY_CODE(state, data) {
      state.currencyCode = data;
    },
    SET_CART_RETAIL(state, data) {
      state.cartRetail = data;
    },
    SET_TOKEN(state, token) {
      state.token = token
    },
    SET_ACCOUNT(state, data) {
      state.account = data
    },
    SET_CUSTOMER_TOKEN(state, token) {
      state.customerToken = token
    },
    SET_PRODUCTS(state, products) {
      state.accountProducts = products
    },
    SET_PAST_RESULTS(state, results) {
      state.pastDrawResults = results
    },
    SET_GAME_RESULTS(state, results) {
      state.pastGameResults = results
    },
    SET_CAROUSEL_PRODUCTS(state, results) {
      state.carouselProducts = results
    },
    SET_MARKETS(state, results) {
      state.markets = results
    },
    SET_SETTINGS(state, results) {
      state.settings = results
    },
    SET_DRAWS(state, results) {
      state.draws = results;
    },
    SET_TRANSLATIONS(state, data) {
      state.translations = data;
    },
    SET_BADGE_NUMBER(state, data) {
      state.badgeNumber = data;
    },
    SET_BADGE_NUMBER_RETAIL(state, data) {
      state.badgeNumberRetail = data;
    },
    SET_PARAMS_LUCKY_NUMBER(state, data) {
      state.paramsLuckyNumber = data;
    }
  },
  actions: {
    initDataCustomer({ commit }, data) {
      if (data.token) {
        commit('SET_TOKEN', data.token)
      }
      if (data.account) {
        commit('SET_ACCOUNT', data.account)
      }
      if (data.currency) {
        commit('SET_CURRENCY_CODE', data.currency)
      }
    },
    addDataToCartRetail({ commit }, data) {
      commit('SET_CART_RETAIL', data)
    },
    changeBadgeNumber({ commit }, data) {
      commit('SET_BADGE_NUMBER', data)
    },

    changeBadgeNumberRetail({ commit }, data) {
      commit('SET_BADGE_NUMBER_RETAIL', data)
    },
    addOrUpdateDraws({ commit }, data) {
      commit('SET_DRAWS', data)
    },
    apiGetMarkets({ commit }, data) {
      this.state.isLoadingMarkets = true;
      MarketService.apiGetMarkets(data.slug).then(res => {
        commit('SET_MARKETS', res)
        this.state.isLoadingMarkets = false;
      })
    },
    apiGetSettings({ commit }) {
      AccountService.accountSettings().then(res => {
        commit('SET_SETTINGS', res)
      })
    },
    apiGetCustomerToken({ commit }, data) {
      TokenService.apiGetToken(data.customerID, data.partnerCode).then(res => {
        commit('SET_CUSTOMER_TOKEN', res)
      })
    },
    getCountries({commit}) {
      CountriesService.getCountries().then(res => {
        const data = Object.entries(res).map(item =>({country_slug: item[0], country_name: item[1]}))
        commit('SET_CAROUSEL_PRODUCTS', data)
      })
    },
    apiGetGames({ commit }) {
      axios.post(this.state.baseAPIUrl + '/api/v2/games', {
            account: this.state.account
          })
          .then(response => {
            if(response.data.status == 'success') {
              commit('SET_PRODUCTS', response.data.results)
            }
          })
          .catch(err => {
            throw err.response.data; // reject
          })
    },
    apiGetResults({ commit }, data) {

      const drawDate = data.drawDate;
      const gameSlug = data.gameSlug;

      const filters = {
        "account": this.state.account,
      };

      if(drawDate) {
        filters["drawType"] = "by-date";
        filters["drawDate"] = drawDate
      }

      if(gameSlug){
        filters["drawType"] = "by-lottery";
        filters["gameSlug"] = gameSlug
      }

      axios.post(this.state.baseAPIUrl + '/api/v2/results', filters)
         .then(response => {
            if(response.data.status == 'success') {

              if(gameSlug) {
                commit('SET_GAME_RESULTS', response.data.results)
              } else {
                commit('SET_PAST_RESULTS', response.data.results)
                commit('SET_GAME_RESULTS', response.data.results)
              }
            }
          })
          .catch(err => {
            throw err.response.data; // reject
          })
    },
    apiGetTranslations({ commit }) {
      axios.post(this.state.baseAPIUrl + '/api/v2/translations', {
        account: this.state.account,
        locale: this.state.locale
      })
          .then(response => {
            if(response.data.status == 'success') {
              commit('SET_TRANSLATIONS', response.data)
            }
          })
          .catch(err => {
            throw err.response.data; // reject
          })
    },
    addParamsLuckyNumber({ commit }, data) {
      commit('SET_PARAMS_LUCKY_NUMBER', data)
    }
  },
  modules: {
  }
})
